import { store } from "store/store";
import { signout } from "layouts/authentication/auth.reducer";

const errorResponseHandler = (error) => {
  // The API only returns 401 for an invalid token (deactivated admin, or the
  // password was changed elsewhere), so drop the session instead of leaving
  // every page failing.
  if (error.response?.status === 401 && store.getState().auth.token) {
    store.dispatch(signout());
  }
  return Promise.reject(error);
};

export default errorResponseHandler;
